import { CardBrands } from 'types';
import { IFormMccCard } from 'modules/CustomersAndRestaurants/Restaurants/EditRestaurant/editRestaurantState/editRestaurantContext';
import MainCardBrandSelect from './MainCardBrandSelect';
import MainMccField from './MainMccField';
import AddButton from './AddButton';
import React from 'react';
import style from './MainMccCard.module.scss';

interface IMainMccCard {
	mccCards: IFormMccCard[];
	useCustomerMcc: boolean;
	selectedMainMccCardBrand: CardBrands | null;
	reservedMccCardBrands: (CardBrands | null)[];
	changeMainMccCardBrand: (value: CardBrands) => void;
	changeMainMccCardMcc: (value: Nullable<number>) => void;
	addMccCard: (value: IFormMccCard) => void;
	setShowAdditionalMccCards: (value: boolean) => void;
}

const MainMccCard: React.FC<IMainMccCard> = ({
	changeMainMccCardBrand,
	changeMainMccCardMcc,
	addMccCard,
	setShowAdditionalMccCards,
	mccCards,
	selectedMainMccCardBrand,
	reservedMccCardBrands,
	useCustomerMcc,
}) => {
	return (
		<div className={style.container}>
			<MainCardBrandSelect
				selectedMainMccCardBrand={selectedMainMccCardBrand}
				reservedMccCardBrands={reservedMccCardBrands}
				changeMainMccCardBrand={changeMainMccCardBrand}
				useCustomerMcc={useCustomerMcc}
			/>
			<MainMccField changeMainMccCardMcc={changeMainMccCardMcc} useCustomerMcc={useCustomerMcc} />
			<AddButton
				useCustomerMcc={useCustomerMcc}
				addMccCard={addMccCard}
				setShowAdditionalMccCards={setShowAdditionalMccCards}
				mccCards={mccCards}
			/>
		</div>
	);
};

export default React.memo(MainMccCard);
